import { useNavigate } from 'react-router-dom';  
import JobList from './JobList';
import MyApplications from './MyApplications';
import './JobList.css';
import React, { useState, useEffect } from 'react';

const ApplyJobs = () => {
  const [activeTab, setActiveTab] = useState('jobs');
  const studentId = localStorage.getItem('userId');
  const navigate = useNavigate();

  useEffect(() => {
    if (!studentId) {
      navigate('/login');
      return;
    }
  }, [studentId, navigate]);

  return (
    <div className="apply-jobs-wrapper">
      <div className="apply-nav">
        <button
          className={`nav-btn ${activeTab === 'jobs' ? 'active' : ''}`}
          onClick={() => setActiveTab('jobs')}
        >
          Apply Jobs
        </button>
        <button
          className={`nav-btn ${activeTab === 'applications' ? 'active' : ''}`}
          onClick={() => setActiveTab('applications')}
        >
          My Applications
        </button>
      </div>

      <div className="apply-content">
        {activeTab === 'jobs' ? <JobList /> : <MyApplications />}
      </div>
    </div>
  );
};

export default ApplyJobs;
